import React, { useEffect, useState } from "react";
import firstimg from "../../../img/step9.png";
import NavHear from "./NavHear";
import Footer from "./TestFooter/Footer";
import { Link, useNavigate } from "react-router-dom";
import BackImg from "../../../img/back.svg";
import { useDispatch } from "react-redux";
import { testQuestion } from "../../../Helper/Redux/API";

function Step9() {
  const history = useNavigate();

  const [selectedOption, setSelectedOption] = useState(
    localStorage.getItem("step9")
  );
  const handleRadioChange = (e) => {
    setSelectedOption(e);
    localStorage.setItem("step9", e);
    // Determine the route path based on the selected option
    let routePath;
    if (e == "36") {
      routePath = "/hearingtest/quiet-environment";
    } else if (e == "37") {
      routePath = "/hearingtest/measurement/right-500";
    } else {
      // Default path or handle other options
      routePath = "/hearingtest/quiet-environment";
    }

    // Navigate to the determined route path after a delay
    setTimeout(() => {
      history(routePath);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 1000);
  };
  const [question, setQuestion] = useState("");
  const [answerOption, serAnswerOption] = useState([]);

  const dispatch = useDispatch();

  const getQuestion = () => {
    const data = {
      page_number: 8,
    };
    try {
      dispatch(testQuestion(data)).then((res) => {
        if (res?.payload?.status === true) {
          setQuestion(res?.payload?.data[0]?.title);
          serAnswerOption(res?.payload?.data[0]?.options);
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);
  return (
    <>
      <div className="test-from">
        <NavHear />{" "}
        <section className="step_form">
          <div className="container">
            {/* container start */}
            <section className="step_1 step2 step9  wow  fadeInUp animated">
              <div className="Back_div">
                <Link to="/hearingtest/headphones">
                  <img src={BackImg} alt="back" className="img-fluid" />
                </Link>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="step1_img">
                    <img src={firstimg} className="img-fluid" alt="first-img" />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="step1_text">
                    <h1>Setup</h1>
                    <div className="setup_option_cont">
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.71312 5.095C8.65087 2.43972 11.5485 0.62177 14.8062 0.0174725C14.9609 -0.0106478 15.12 -0.00476773 15.2722 0.0346947C15.4244 0.0741572 15.5659 0.146233 15.6867 0.2458C15.8075 0.345367 15.9046 0.469981 15.9711 0.610784C16.0376 0.751588 16.0718 0.905124 16.0714 1.06048V23.9422C16.0714 24.2227 15.9586 24.4918 15.7576 24.6902C15.5567 24.8885 15.2842 25 15.0001 25C14.935 25.0003 14.87 24.9943 14.8062 24.982C11.5487 24.3772 8.65125 22.5594 6.71312 19.9045H5.35678C3.93677 19.9022 2.57557 19.3443 1.57147 18.3529C0.567368 17.3614 0.00226658 16.0174 0 14.6154V10.3841C0.00226658 8.98203 0.567368 7.63803 1.57147 6.64662C2.57557 5.6552 3.93677 5.09724 5.35678 5.095H6.71312ZM8.17338 18.2701C9.53281 20.3183 11.5646 21.8423 13.9276 22.586V2.41343C11.5673 3.15914 9.5386 4.68376 8.18195 6.73145C8.08457 6.8786 7.95159 6.99946 7.79503 7.08313C7.63846 7.16679 7.46325 7.21062 7.28523 7.21064H5.35678C4.50436 7.21064 3.68685 7.54499 3.08409 8.14013C2.48134 8.73526 2.14271 9.54245 2.14271 10.3841V14.6154C2.14271 15.457 2.48134 16.2642 3.08409 16.8593C3.68685 17.4545 4.50436 17.7888 5.35678 17.7888H7.27666C7.45488 17.7891 7.63022 17.8332 7.7868 17.9173C7.94338 18.0013 8.07625 18.1226 8.17338 18.2701ZM21.5116 4.75854C21.4099 4.66525 21.2893 4.59125 21.1565 4.54076C21.0236 4.49027 20.8813 4.46429 20.7375 4.46429C20.5938 4.46429 20.4514 4.49027 20.3186 4.54076C20.1858 4.59125 20.0651 4.66525 19.9635 4.75854C19.8618 4.85183 19.7812 4.96258 19.7262 5.08447C19.6712 5.20636 19.6429 5.33699 19.6429 5.46893C19.6429 5.60086 19.6712 5.7315 19.7262 5.85338C19.7812 5.97527 19.8618 6.08602 19.9635 6.17931C21.7873 7.85703 22.8115 10.1301 22.8115 12.5C22.8115 14.8699 21.7873 17.143 19.9635 18.8207C19.7582 19.0091 19.6429 19.2646 19.6429 19.5311C19.6429 19.7975 19.7582 20.0531 19.9635 20.2415C20.1688 20.4299 20.4472 20.5357 20.7375 20.5357C21.0279 20.5357 21.3063 20.4299 21.5116 20.2415C23.7455 18.1867 25 15.4026 25 12.5C25 9.5974 23.7455 6.81332 21.5116 4.75854ZM18.6351 7.4585C18.5444 7.35868 18.4367 7.27943 18.3182 7.22527C18.1996 7.17111 18.0725 7.14311 17.944 7.14286C17.8156 7.14261 17.6884 7.17012 17.5696 7.22382C17.4509 7.27752 17.3429 7.35635 17.252 7.45582C17.161 7.55529 17.0888 7.67345 17.0394 7.80355C16.99 7.93365 16.9645 8.07314 16.9643 8.21406C16.9641 8.35499 16.9891 8.49458 17.0381 8.62486C17.087 8.75515 17.1589 8.87359 17.2495 8.97341C18.1011 9.90922 18.5794 11.1776 18.5794 12.5C18.5794 13.8224 18.1011 15.0908 17.2495 16.0266C17.1589 16.1264 17.087 16.2448 17.0381 16.3751C16.9891 16.5054 16.9641 16.645 16.9643 16.7859C16.9645 16.9269 16.99 17.0663 17.0394 17.1964C17.0888 17.3265 17.161 17.4447 17.252 17.5442C17.4357 17.7451 17.6846 17.8576 17.944 17.8571C18.0725 17.8569 18.1996 17.8289 18.3182 17.7747C18.4367 17.7206 18.5444 17.6413 18.6351 17.5415C19.8522 16.2035 20.5357 14.3904 20.5357 12.5C20.5357 10.6096 19.8522 8.79649 18.6351 7.4585Z"
                            fill="#737373"
                          />
                        </svg>{" "}
                        <span>Set your device volume to 100%</span>
                      </div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="29"
                          viewBox="0 0 30 29"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14 0H16V14.1689L14 12.1936V0ZM14 17.5028V29H16V19.4782L19 22.4411V24H20.5783L24.7276 28.0981L26.3818 26.4232L5.39838 5.69867L3.74414 7.37357L5.39087 9H4V20H6V9.60159L9 12.5645V24H11V14.5399L14 17.5028ZM11 5V9.23056L9 7.25519V5H11ZM19 17.132L21 19.1074V5H19V17.132ZM24 9H26V20H24V9ZM28 12H30V17H28V12ZM0 12H2V17H0V12Z"
                            fill="#737373"
                          />
                        </svg>
                        <span>
                          Turn off noise-cancelling in your headphones
                        </span>
                      </div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26"
                          height="26"
                          viewBox="0 0 26 26"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M14.328 0.0276763C10.9987 -0.20264 7.72687 1.0159 5.36658 3.37619C4.92236 3.8204 4.51862 4.29751 4.15735 4.80166L5.5094 6.23062C5.86182 5.69436 6.26947 5.19082 6.729 4.72903C8.53284 2.92526 10.9794 1.91781 13.5316 1.91781C13.7523 1.91781 13.9826 1.91781 14.2032 1.93698C19.2021 2.28238 23.1071 6.62881 23.1071 11.8291V17.4132C23.1071 19.62 21.9462 21.1071 20.2287 21.1071H19.585L21.2912 22.9105C23.5334 22.4055 25.0261 20.2898 25.0261 17.4132V11.8291C25.0261 5.63095 20.3246 0.440213 14.328 0.0276763ZM2.79065 7.32406L0 4.3746L1.45276 3.00003L21.384 24.0654L19.9312 25.44L17.6472 23.0261H13.8387C7.63092 23.0261 2.44019 18.3247 2.02759 12.328C1.90845 10.6047 2.17743 8.89676 2.79065 7.32406ZM15.8316 21.1071H13.8387C8.63837 21.1071 4.29193 17.1925 3.94653 12.2033C3.86908 11.0796 3.98877 9.9653 4.2879 8.90652L15.8316 21.1071Z"
                            fill="#737373"
                          />
                        </svg>{" "}
                        <span>Make sure You’re in a quiet environment</span>
                      </div>
                    </div>

                    <div className="step2_seletct step4_seletct">
                      <ul
                        className="list_item   hearselect "
                        style={{ gap: "20px" }}
                      >
                        {/* {answerOption?.map((option, i) => (
                            <li key={i}>
                              <div
                                className={`form-check form-check-inline ${
                                  selectedOption == option?.id ? "checked" : ""
                                }`}
                              >
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="inlineRadioOptions"
                                  id={`inlineRadio${i}`}
                                  value={option?.id}
                                  checked={selectedOption == option?.id}
                                  onChange={(e) =>
                                    handleRadioChange(e.target.value)
                                  }
                                />
                                <label
                                  className="form-check-label"
                                  for={`inlineRadio${i}`}
                                >
                                  {option?.title}
                                </label>
                              </div>
                            </li>
                          ))} */}
                        <li>
                          <button
                            className="measure_btns"
                            onClick={() =>
                              history("/hearingtest/quiet-environment")
                            }
                          >
                            Measure Background Noise
                          </button>
                        </li>
                        <li>
                          <button
                            className="measure_btns"
                            onClick={() =>
                              history("/hearingtest/measurement/right-500")
                            }
                          >
                            Skip and start the tone test
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* container end */}
          </div>

          {/* <Link to="/hearingtest/quiet-environment">
            {" "}
            <button className="btn">Let’s Start!</button>
          </Link> */}
        </section>
        <Footer />
      </div>
    </>
  );
}

export default Step9;
